import { createAsyncThunk } from '@reduxjs/toolkit'
import { getValuation } from '../../clients/valuationClient'
import { ValuationResponse } from '../../@types/valuation'
import { Lead } from '../../@types/lead'
import { PropertyLocation } from '../../@types/location'
import { Resource } from '../../@types/resource'
import { Address } from '../../@types/address'
import { STEP } from '../../@types/state'

export interface ThunkStateConfig {
  state: {
    lead: Lead
    address: Resource<Address>
    location: Resource<PropertyLocation>
  }
}

export interface ValuationThunkRequest {
  successCallback?: (result: ValuationResponse) => unknown
  errorCallback?: (error: ErrorConstructor) => void
  valuationForStep?: STEP
}

const fetchValuation = createAsyncThunk<ValuationResponse, ValuationThunkRequest, ThunkStateConfig>(
  'valuation/fetch',
  async (valuationThunkRequest, thunkAPI) => {
    const { lead, location, address } = thunkAPI.getState()
    const { successCallback, errorCallback, valuationForStep } = valuationThunkRequest
    if (!location.data) {
      throw new Error("No location given. Can't get valuation")
    }
    return await getValuation({
      lead: lead,
      postcode: location.data.postcode,
      city: location.data.city,
      street: address.data?.street,
      houseNumber: address.data?.houseNumber,
      valuationForStep: valuationForStep,
    })
      .then((result) => {
        successCallback && successCallback(result)
        return result
      })
      .catch((error) => {
        errorCallback && errorCallback(error)
        throw error
      })
  }
)

export { fetchValuation }
